module.exports = __webpack_public_path__ + "static/img/Railway freight_image.03e5f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/Railway freight_image.png
// module id = 8cmR
// module chunks = 44